import React from "react";

const Footer = () => {
  return (
    <footer>
      <p className="bg-dark py-3 text-white text-center s-color m-0">
        Copyright © 2021 | Design & Developed By
        <a
          className="text-decoration-none p-color ms-2"
          href="https://www.facebook.com/asifiqbal.munna.5/"
        >
          Asif Iqbal Munna
        </a>
      </p>
    </footer>
  );
};

export default Footer;
